import { render } from "./product-charge.vue?vue&type=template&id=5356f370&lang=html"
import script from "./product-charge.vue?vue&type=script&lang=js"
export * from "./product-charge.vue?vue&type=script&lang=js"

import "./product-charge.vue?vue&type=style&index=0&id=5356f370&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__